import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Formik } from 'formik';
import { useMemo } from 'react';
import * as Yup from 'yup';
import Axios from '../../../common/axiosInterceptor';
import { FormikTextField } from '../../../common/formik-material-ui';
import { useSnackbarWithStyles } from '../notifications/SnackbarProviderWithStyles';
import { ModalWithStyles } from './ModalWithStyles';

const useStyles = makeStyles((theme) => ({
  field: {
    marginTop: theme.spacing(1), // space between fields
    marginBottom: theme.spacing(1), // space between fields
  },
  button: {
    marginLeft: theme.spacing(1), // space between fields
  },
}));
export function ForgetPasswordModal({ show, onHide }) {
  const { enqueueSnackbarWithStyles } = useSnackbarWithStyles();
  const classes = useStyles();
  const forgotPasswordSchema = useMemo(
    () =>
      Yup.object({
        email: Yup.string()
          .required('Required')
          .email('Must be a valid Email Address'),
      }),
    []
  );
  return (
    <Formik
      onSubmit={async (values, actions) => {
        const url = `${process.env.VITE_APP_API_DOMAIN}/itn/legacy/forgotPassword`;
        const result = await Axios.post(url, {
          call: 'forgotPassword',
          email: values.email,
          react: true,
        });
        if (result?.data?.success) {
          enqueueSnackbarWithStyles({
            message: result?.data?.message,
            persist: true,
            alertProps: { severity: 'success' },
          });
          actions.resetForm({});
          onHide();
        } else {
          enqueueSnackbarWithStyles({
            message:
              'There was a problem ressetting your password please contact kixie support',
            alertProps: { severity: 'error' },
            persist: true,
          });
        }
        // console.log(result, 'result of submitting forgot password ajax');
      }}
      initialValues={{
        email: '',
      }}
      validationSchema={forgotPasswordSchema}
    >
      {(formik) => (
        <>
          <form
            className="form form-label-right"
            onSubmit={formik.handleSubmit}
            noValidate
          >
            <ModalWithStyles
              title="Forgot Password"
              show={show}
              onHide={onHide}
              isSubmitting={formik.isSubmitting}
              size="sm"
              footerComponent={
                <div>
                  <Button
                    data-qa="cancel-forgot-password-email"
                    className={classes.button}
                    disableElevation
                    variant="contained"
                    disabled={formik.isSubmitting}
                    onClick={onHide}
                  >
                    Cancel
                  </Button>
                  <Button
                    data-qa="send-forgot-password-email"
                    className={classes.button}
                    style={{ marginRight: '10px' }}
                    disableElevation
                    variant="contained"
                    color="primary"
                    disabled={!formik.dirty || !formik.isValid}
                    onClick={formik.handleSubmit}
                  >
                    Send Email
                  </Button>
                </div>
              }
            >
              <FormikTextField
                name="email"
                className={classes.field}
                formik={formik}
                fullWidth
                label="Email"
                size="small"
                required
                variant="outlined"
                inputProps={{ 'data-qa': 'forgot-password-email-input' }}
              />
            </ModalWithStyles>
          </form>
        </>
      )}
    </Formik>
  );
}
